module.exports = __webpack_public_path__ + "ec289897c2eb15917ea071041d39b47d.png";